import { render, staticRenderFns } from "./active-indices.vue?vue&type=template&id=abe50ecc&"
import script from "./active-indices.vue?vue&type=script&lang=js&"
export * from "./active-indices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports